import React from 'react';

export default function EmptyState({ icon: Icon, title, description, action, testid }) {
  return (
    <div
      className="flex flex-col items-center justify-center text-center py-16 px-6 rounded-2xl border border-dashed border-border bg-card/60"
      data-testid={testid || 'empty-state'}
    >
      {Icon && (
        <div className="mb-4 h-14 w-14 rounded-2xl bg-brand-light flex items-center justify-center">
          <Icon className="h-7 w-7 text-brand" />
        </div>
      )}
      <h3 className="text-lg font-bold text-foreground">{title}</h3>
      {description && <p className="mt-1.5 text-sm text-muted-foreground max-w-sm">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
